<template>
  <sc-render :fields="fields" :empty-message="$t('NO_DATA_SOURCE_EXIST')">
    <div v-if="isExperienceEditor" class="edit-images-container">
      <sc-image :media="desktopImageField" />
    </div>
    <div v-else class="image-container">
      <picture>
        <source :srcset="mobileImageSrc" media="(max-width: 420px)">
        <img :src="desktopImageSrc" :alt="desktopImageAlt" />
      </picture>
    </div>
  </sc-render>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import { Image } from '@sitecore-jss/sitecore-jss-vue'
  import get from '~/helpers/get'
  import ScRender from '../sc-render/index'

  const { mapState: mapJssState } = createNamespacedHelpers('jss')

  export default {
    name: 'EditorialFullImage',
    components: {
      ScRender,
      ScImage: Image
    },
    props: {
      fields: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      ...mapJssState(['isExperienceEditor']),
      desktopImageField () {
        return get(this.fields, 'desktopImage')
      },
      mobileImageField () {
        return get(this.fields, 'mobileImage')
      },
      desktopImageValue () {
        return get(this.desktopImageField, 'value')
      },
      mobileImageValue () {
        return get(this.mobileImageField, 'value')
      },
      desktopImageSrc () {
        return get(this.desktopImageValue, 'cloudinary_4x3_fill_crop')
          || get(this.desktopImageValue, 'src', '')
      },
      mobileImageSrc () {
        return get(this.mobileImageValue, 'cloudinary_3x4_fill_crop')
          || get(this.mobileImageValue, 'src', '')
      },
      desktopImageAlt () {
        return get(this.desktopImageValue, 'alt', '')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .edit-images-container,
  .image-container {
    @include stack-space($space-090);
    @include tablet {
      @include stack-space($space-100);
    }
    ::v-deep img {
      display: block;
      width: 100%;
      height: auto;
      &.scEmptyImage {
        width: auto;
        margin: 0 auto;
      }
    }
  }
</style>
